
<div mat-dialog-title>External accounts cannot be imported<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content style="overflow-y: auto!important;max-height: 79vh;">
  <mat-card class="warn block">
    @if (warn_main) {
      <mat-card-title class="warn">{{warn_main}}</mat-card-title>
    }
    <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">
      @if (hasValidRecords) {
        <div class="block">You can continue the import without these accounts, or cancel the entire import.</div>
      }

      @if (needsAdditionalAction) {
        <div class="block">
          <div>{{additionActionCount}} external accounts in your file need additional action to be imported.</div>
          <ul>
            @if (data.deletedExtAccts.length > 0) {
              <li>Deleted accounts: Select which accounts to restore</li>
            }
            @if (data.overrideExtAccts.length > 0) {
              <li>Duplicate accounts: If you continue this import containing duplicate accounts, existing holdings will be overwritten</li>
            }
          </ul>
        </div>
      }

      @if (!hasValidRecords && !needsAdditionalAction) {
        <div>The records listed below will not get imported.</div>
      }
    </mat-card-subtitle>
  </mat-card>
  <div>
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'140px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      [rowData] = 'invalidAndOverriddenRecords'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid>
  </div>
  @if (data.deletedExtAccts?.length > 0) {
    <div>
      <div class="block">Deleted Accounts: Select which accounts to restore.</div>
      <div>
        <irb-inventory-grid
          [style.width] = "'100%'"
          [style.height] = "'140px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptionsDeletedExtAccts"
          [frameworkComponents] = 'gridOptionsDeletedExtAccts.frameworkComponents'
          [rowData] = 'deletedExtAccts'
        (gridReady) = "onGridOptionsDeletedExtAcctsReady($event)"></irb-inventory-grid>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
  <button id="continueButton" (click)="completeImport()"
    [disabled]="!hasValidRecords && disableContinueBtn" class="btn-medium-primary">Continue
  </button>
</mat-dialog-actions>
